<div class="app-container">
  <header class="site-header" *ngIf="showHead">
    <header-menu></header-menu>
  </header>

  <main class="content">
    <router-outlet></router-outlet>
  </main>

  <footer class="site-footer" *ngIf="showFooter">
    <app-footer></app-footer>
  </footer>
</div>
